// extracted by mini-css-extract-plugin
export var avatar = "_p9-3";
export var avatarContainer = "_p9-2";
export var avatarSpacer = "_p9-5";
export var avatarSpacerContainer = "_p9-4";
export var avatarStackContainer = "_p9-1";
export var bubble = "_p9-0";
export var remainderBubble = "_p9-6";